import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, GridCell, Button, Typography, Card, Icon, IconToggle, List, ListItem } from 'rmwc';
import { TabBar, Tab, TabIcon, TabIconText, TabBarScroller } from 'rmwc/Tabs';
import { LoadingBar } from '../../components/util/LoadingBar';
import { logEvent } from '../../helpers/analytics';

import { CTAOpt } from '../../components/Onboarding/CtaVariants';
import { ScoreVariantCurrent } from '../../components/Onboarding/ScoreVariants';
import { Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { Text } from '../../components/Text';
import { withEmailDialog } from '../../components/EmailDialog';
import { isTest } from '../../helpers/environment';

//Use google sheets to save as tsv, then convert tabs to pipes and copy here.
export const pipesv = [
  '|Source|Checklist Item|Title Text|Grey Color Text|Tool Flow Description (what we will do together)|Explicit Copy|$ Value|Score Impact|When to do it|Category|||',
  '||Asset Mix|Double-check your investment portfolio|The average American is underperforms the market by 4%|Compare your investments to an ideal target portfolio, and rebalance if necessary.|Link your accounts for an asset-mix review, get suggestions on how to improve your mix|3000|0.012|This year|Wealth Management|||',
  '||Account Gaps|Maximize tax-advantaged savings|Tax-advantaged accounts can lower your tax bill by over 15%|Find out if you are missing accounts that could help you minimize your taxes|Fill in what type of accounts you have and answer questions about your eligibility and we will show you how much you are losing to taxes by not having the right accounts|975|0.009|This year|Saving and Budgeting|||',
  "|/start/investment-fees|Investment fees|Check your investment fund expenses|You could be paying an extra $3,000/year in investment fees|Compare the fees you are paying on your current investments, to what you would get from similar, lower cost funds|Tell us your priorities and link your investments, so we can check 100's of similar options for lower costs|855|0.009|Now|Wealth Management|||",
  "||Social Security|Maximize your Social Security|57% of people claim Social Security early and lose $1,000's in payouts|Estimate your benefits and figure out what age earns you the highest payouts|Input your income history and use your life expectancy to find what claim age will earn you the most in payouts|6000|0.0135|At Age 60|Life Events|1||",
  '||Expense review|Cut unnecessary expenses|The average household spends $4,108/year on coffee and dining out|Link your bank account data to get a detailed spending analysis|Link you bank accounts and credit cards so we can analyze your spending for you and point out ways to save|900|0.009|Next year|Saving and Budgeting|2||',
  '||Debt Analysis|Consolidate or refinance your debt|The average refinancing saves $3,012/year in payments|Check your debt to see if you could save on interest payments|Link your credit report and fill in some details about loans you have taken, we will find you offers to reduce your interest rates|3000|0.0105|Next year|Saving and Budgeting|3||',
  '||Advisor match|Find a financial advisor|Expert advice normally results in 10% more to spend in retirement|Answer questions to find a personalized match to an in-person or an online advisor |Answer questions to find a personalized match to an in-person or an online advisor |1000|0.0135|Next year|Wealth Management|4||',
  '||Healthcare expenses|Estimate healthcare expenses|A healthy couple can expect to spend $266,600 on retirement healthcare|Find suggestions for how to prepare for healthcare expenses and how to make them more affordable|Answer questions about your health and habits, get a detailed healhcare expense estimate, and get suggestions for how to best afford them|1000|0.0105|At Age 60|Healthcare|5||',
  "||401(k) rollovers|Check on your 401(k) plan|The average 401(k) charges admin fees of 0.42%/year|Decide if it's worth it to keep your 401(k), or if you should rollover to an IRA|Tell us about your account preferences and 401(k) provider, we will make a recommendation for staying in your 401(k) or rolling over to an IRA|750|0.0105|Next year|Wealth Management|6||",
  '||Longevity|Plan your longevity|For a 65 year old couple there is a 45% chance that at least one spouse will live past 90 years old|Estimate how long you will live and get suggestions for how to prepare for expenses in advanced age|Answer questions about your health and habits, get a detailed longevity estimate with personalized suggestions for how to manage living to that age|930|0.0105|Dont include|Life Events|||',
  '||Finanical Shock|Get a financial shock analysis|In the great recession, market values fell by half|Link your investments to figure out if you have any large risks for a market crash|Link your investments to figure out if you have any large risks for a market crash|360|0.0045|Dont include|Wealth Management|||',
  '||Annuity|Use a deep deferred annuity|Lifetime income from deferred annuities is ideal if you live past 83|See if a deep deferred annuity would provide the income you need at 85+|Estimate your longevity and see if an annuity starting at 85 can cover most of your essential expenses|650|0.009|At Age 60|Wealth Management|||',
  "||Housing |Downsize your home|37% of homeowners would like to downsize their home|See how much you could save by moving into a smaller home or to a low-tax state |We'll analyze your current home expenses and compare them to homes that meet your downsizing requirments to estimate achievable cost savings|7000|0.0135|At Retirement|Life Events|||",
  '||Healthcare Plan|Select a healthcare plan|There are 438 Medicare Part D plans to choose between|Compare your needs to the best fit among Medicare plans, and find the one with the lowest cost|Enter your needs and preferences and find the Medicare plans that best suit your needs, at the lowest cost|1,050|0.0105|Dont include|Healthcare|||',
  '||Tax savings|Find tax savings opportunities |Smart tax strategy can produce 3.23% more income every year|Advice on which accounts to withdraw from so you pay the lowest taxes possible|Link your investments and we will tell you month by month where you should withdraw from in order to pay the lowest possible taxes|$1,450|0.012|Dont include|Saving and Budgeting|||',
  '|375 avg cost of a will. 4000 per $100k of inheritance, probate fees|Legacy|Set up a will|Avoid paying probate fees and other costs|Enter basic details about your legacy goals, so you can set up a will|Enter basic details about your legacy goals and we will generate a lawyer approved will and help you file it away for safe keeping |425|0.0075|At Retirement|Life Events|||',
  '||Long Term Care|Protect against being dependent|Assisted living costs $3,500 a month|Find ways to pay for long term care, if needed|Estimate your need for long-term care and review the best providers|1167|0.0105|At Retirement|Healthcare|||',
  '|2% increase in savings rate from expert advice|Participation Rate|Set how much you save|With expert advice, people tend to save $900 more per year|Set a savings rate that gets you closer to your goals|See the impact of savings over time and get help setting your monthly savings contribution |637|0.0075|Next year|Saving and Budgeting||-$11,320.10|$636.89',
  "||Insurance analysis |Test your insurance protection|Make sure you're protected from catastophic loss|Walk through coverage on your most important assets and figure out how much you want|Walk through coverage on your most important assets and figure out how much you want|267|0.0045|Next Year|Life Events|||",
  "|https://venturebeat.com/2012/12/11/the-average-american-spends-857-on-monthly-subscriptions-infographic/|Cancel Subscriptions |Eliminate Subscriptions |The average American spends $900/year on unnecessary subscriptions|Get help automatically cancelling or renegotiating your subsciptions|We'll check your bank statement for subscription payments and mkae it easy for you to cancel or renegotiate your subscription |463|0.0045|Dont include|Saving and Budgeting|||",
];

export const ActionItemGroup = ({ children }) => (
  <List style={{ marginTop: '1rem', marginBottom: '2rem', borderTop: '1px solid #E0E0E0', padding: '0' }}>
    {children}
  </List>
);

export const ActionItem = ({ onContinue, onClick, open, data }) => {
  return (
    <div style={{ borderBottom: '1px solid #E0E0E0', backgroundColor: 'white', width: '100%' }}>
      <ListItem
        onClick={onClick}
        style={{
          height: 'auto',
          padding: '0',
          cursor: 'pointer',
        }}
      >
        <div style={{ height: '70px', width: '78px', padding: '10px 14px' }}>
          <img src={getImage(data[10])} style={{ height: 50 }} />
        </div>
        <div style={{ width: '600px' }}>
          <Typography tag="div" use="subtitle1">
            {data[3]}
          </Typography>
          <Typography
            tag="div"
            className="mb-1"
            use="body1"
            style={{ marginTop: '-4px' }}
            theme="text-secondary-on-background"
          >
            {data[4]}.
          </Typography>
        </div>
        <div style={{ width: '174px', lineHeight: '1.25rem', textAlign: 'right', paddingRight: '10px' }}>
          <Typography use="body1">
            Spend up to{' '}
            <Typography use="body1" style={{ color: '#00B050' }}>
              +<Money amount={data[7]} />/yr
            </Typography>
            <br />
            more in retirement.
          </Typography>
        </div>
        <div style={{ width: '48px' }}>
          <Icon style={{ display: 'block', margin: '12px' }}>{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
        </div>
      </ListItem>
      {open && (
        <div style={{ padding: '0rem 48px 1rem 78px' }}>
          <Typography tag="div" use="subtitle1" className="mb-2">
            {data[5]}
          </Typography>
          <div>
            <Button onClick={onContinue} theme="secondary-bg on-secondary">
              Start this free tool
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export const getImage = key => {
  if (key == 'Wealth Management') {
    return require('images/module-wealth.png');
  } else if (key == 'Saving and Budgeting') {
    return require('images/module-savings.png');
  } else if (key == 'Life Events') {
    return require('images/module-social.png');
  } else if (key == 'Healthcare') {
    return require('images/module-healthcare.png');
  }
};

export const getItems = ({ keys = [], times = [], notTimes = [] }) => {
  let r = [];
  for (let i of pipesv) {
    let data = i.split('|');
    if (keys.length != 0 && keys.indexOf(data[10]) == -1) {
      continue;
    }
    if (times.length != 0 && times.indexOf(data[9]) == -1) {
      continue;
    }
    if (notTimes.length != 0 && notTimes.indexOf(data[9]) != -1) {
      continue;
    }
    r.push(data);
  }
  return r;
};

export class ActionPlanComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      activeNow: 0,
      activeLater: -1,
      activeTab0: -1,
      activeTab1: -1,
      activeTab2: -1,
      activeTab3: -1,
      pdfRequested: false,
      scrolled: false,
    };
  }

  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll(event) {
    if (!this.state.scrolled) {
      this.setState({
        scrolled: true,
      });
      logEvent('ActionPlanScrolled');
    }
  }

  continue(object) {
    logEvent('ActionPlanContinue', {
      clicked: object[3],
    });
    if (object[1] != '') {
      this.props.history.push(object[1]);
    } else {
      this.props.onContinue();
    }
  }

  advisorContinue(clicked) {
    logEvent('ActionPlanContinue', {
      clicked: clicked,
    });
    this.props.history.push(`/start/review-plan`);
  }

  changeTab = evt => {
    logEvent('ActionPlanChangeTab', {
      clicked: evt.target.value,
    });
    this.setState({ activeTab: evt.target.value });
  };

  changeActive(index, clickedKey) {
    const newKey = this.state[index] == clickedKey ? -1 : clickedKey;
    this.setState({ [index]: newKey });
    logEvent('ChangeActiveActionPlan', {
      group: index,
      show: newKey,
    });
  }

  render() {
    const { people, results, onContinue, openRegistrationDialog } = this.props;
    const {
      activeTab,
      activeNow,
      activeLater,
      activeTab0,
      activeTab1,
      activeTab2,
      activeTab3,
      pdfRequested,
    } = this.state;

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    return (
      <div>
        <div
          style={{
            maxWidth: '924px',
            backgroundColor: '#E0F3FF',
            marginLeft: '-12px',
            padding: '12px 12px 0',
            borderBottom: '1px solid white',
          }}
          className="mb-4 actionPlanIntro"
        >
          <Typography use="headline6" tag="div">
            Top action for right now
          </Typography>
          <Typography use="body1" tag="div">
            Your time is valuable, so we've picked the <strong>highest impact step</strong> to get you started right
            away.
          </Typography>
          <ActionItemGroup>
            {getItems({ times: ['Now'] }).map((object, i) => (
              <ActionItem
                open={i == activeNow}
                onClick={() => this.changeActive('activeNow', i)}
                data={object}
                key={i}
                onContinue={() => this.continue(object)}
              />
            ))}
          </ActionItemGroup>

          <hr style={{ margin: '0.75rem -0.75rem', border: 'none', borderTop: '1px solid #cccccc' }} />

          <Typography use="headline6" tag="div">
            Actions for later this year
          </Typography>
          <Typography use="body1" tag="div">
            You don't have to do it all at once. We'll send you a reminder about these later on, when you have a little
            more time.
          </Typography>
          <ActionItemGroup>
            {getItems({ times: ['This year'] }).map((object, i) => (
              <ActionItem
                open={i == activeLater}
                onClick={() => this.changeActive('activeLater', i)}
                data={object}
                key={i}
                onContinue={() => this.continue(object)}
              />
            ))}
          </ActionItemGroup>

          <hr style={{ margin: '0.75rem -0.75rem', border: 'none', borderTop: '1px solid #cccccc' }} />

          <Typography use="headline6" tag="div">
            The rest of your plan
          </Typography>
          <Typography use="body1" tag="div">
            We've identified an additional <strong>12 opportunities</strong> between now and retirement. We'll help you
            with them all when it's time!
          </Typography>
          <div className="mt-3">
            <TabBar activeTab={this.state.activeTab} onChange={this.changeTab}>
              <Tab>Life Events</Tab>
              <Tab>Wealth Management</Tab>
              <Tab>Saving &amp; Budgeting</Tab>
              <Tab>Healthcare</Tab>
            </TabBar>
            <ActionItemGroup>
              {this.state.activeTab == 0 &&
                getItems({ keys: ['Life Events'], notTimes: ['Now', 'This year', 'Dont include'] }).map((object, i) => (
                  <ActionItem
                    open={i == activeTab0}
                    onClick={() => this.changeActive('activeTab0', i)}
                    data={object}
                    key={i}
                    onContinue={() => this.continue(object)}
                  />
                ))}
              {this.state.activeTab == 1 &&
                getItems({ keys: ['Wealth Management'], notTimes: ['Now', 'This year', 'Dont include'] }).map(
                  (object, i) => (
                    <ActionItem
                      open={i == activeTab1}
                      onClick={() => this.changeActive('activeTab1', i)}
                      data={object}
                      key={i}
                      onContinue={() => this.continue(object)}
                    />
                  )
                )}
              {this.state.activeTab == 2 &&
                getItems({ keys: ['Saving and Budgeting'], notTimes: ['Now', 'This year', 'Dont include'] }).map(
                  (object, i) => (
                    <ActionItem
                      open={i == activeTab2}
                      onClick={() => this.changeActive('activeTab2', i)}
                      data={object}
                      key={i}
                      onContinue={() => this.continue(object)}
                    />
                  )
                )}
              {this.state.activeTab == 3 &&
                getItems({ keys: ['Healthcare'], notTimes: ['Now', 'This year', 'Dont include'] }).map((object, i) => (
                  <ActionItem
                    open={i == activeTab3}
                    onClick={() => this.changeActive('activeTab3', i)}
                    data={object}
                    key={i}
                    onContinue={() => this.continue(object)}
                  />
                ))}
            </ActionItemGroup>
          </div>
        </div>

        <Text use="headline5" className="mb-1">
          What's next?
        </Text>
        <Typography use="body1" tag="div" className="mb-2">
          If you're ready to start taking control of your retirement, we're here to help!
        </Typography>
        <div style={{ display: 'flex' }} className="mb-2">
          <CTAOpt
            title="Get started on your own"
            subtitle="For do-it-yourselfers."
            image={require('images/onboarding-diy.png')}
            description="Use our software to explore your recommendations, and put them into action. We'll guide you through every step."
            buttonText="Get started for free"
            onClick={() => this.continue('Get started on your own')}
          />
          <CTAOpt
            title="Intro with an Advisor"
            subtitle="A free 30-minute session."
            image={require('images/onboarding-conversation.png')}
            description="If you have questions about this plan, or have something specific you want help with, join one of our advisors for a short call online."
            buttonText="Schedule free intro"
            onClick={() => this.advisorContinue('Intro with an Advisor')}
          />
        </div>
        <Typography use="body1" tag="div" className="mt-3">
          Prefer to do it on your own? Make sure to download a PDF of your plan so you can follow it yourself!
        </Typography>
        <Typography use="body1" tag="div" className="mt-1 mb-1">
          {pdfRequested ? (
            'We will contact you shortly with your plan.'
          ) : (
            <Button
              theme="secondary"
              onClick={() =>
                this.props.openEmailDialog(() => this.setState({ pdfRequested: true }), () => {}, 'PDF_EMAIL')
              }
            >
              Download a plan copy
            </Button>
          )}
        </Typography>
      </div>
    );
  }
}

export class ActionPlan extends Component {
  componentDidMount() {
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }
  }

  render() {
    const { people, results, onContinue, openEmailDialog, history } = this.props;

    if (!people) {
      return <LoadingBar />;
    }

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    return (
      <div className="container-fluid pb-4">
        <div style={{ maxWidth: '900px' }} className="mb-4">
          <div className="mt-3 mb-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text use="headline5" className="mt-1 mb-0">
              Your Retirement Action Plan
            </Text>
            <div style={{ display: 'inline-block' }}>
              <Button theme="secondary-bg on-secondary" raised onClick={() => history.push('/start/plan-intro')}>
                Back to Summary
              </Button>
            </div>
          </div>

          <Text use="body1">
            We’ve evaluated <strong>25 areas</strong> of your finances and prepared a step-by-step plan to make your
            retirement better!
          </Text>
        </div>
        <ActionPlanComponent onContinue={onContinue} history={history} openEmailDialog={openEmailDialog} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    people: state.people.data,
    results: state.simulations.results,
  };
}

export default withEmailDialog(connect(mapStateToProps, { runFullSimulation })(ActionPlan));
